const PLATFORM_TIMEZONE = 'Africa/Kinshasa';

export function getFormateurAttendanceTodayKey(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: PLATFORM_TIMEZONE }).format(new Date());
}

export function getAttendanceCalendarDateKey(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-CA', { timeZone: PLATFORM_TIMEZONE }).format(d);
}

export function attendanceDayKey(iso: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  return getAttendanceCalendarDateKey(iso) || iso.slice(0, 10);
}

export function isFormateurAttendanceEditableDate(dateSeance: string): boolean {
  return attendanceDayKey(dateSeance) === getFormateurAttendanceTodayKey();
}
